import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'
export const exportExcel = (rowData: any) => {
  const worksheet = XLSX.utils.json_to_sheet(rowData)
  const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  })

  saveAsExcelFile(excelBuffer, 'Data')
}

export const saveAsExcelFile = (buffer: any, fileName: string) => {
  const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const EXCEL_EXTENSION = '.xlsx'
  const data = new Blob([buffer], { type: EXCEL_TYPE })
  saveAs(data, `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`)
}
